import $ from 'jquery';
import asimov from '../core';
import OffCanvas from './lib/off-canvas';

var pluginName = 'offCanvas',
    defaults = {
        'name': '',
        'variation': 'left'
    };

function build(options, elem) {
    var obj = new OffCanvas().init(options, elem);

    return {
        toggle: function() {
            if (obj.isOpen()) {
                obj.close();
            } else {
                obj.open();
            }

            return this;
        }
    };
}

// Plugin definition

$.fn[pluginName] = function(options) {
    return this.each(function() {
        if (!$.data(this, pluginName)) {
            var opts = asimov.mergeElementData(
                $(this),
                'oc',
                $.extend(true, {}, defaults, options)
            );

            $.data(this, pluginName, build(opts, this));
        }
    });
};



// WEBPACK FOOTER //
// ./node_modules/@99designs/asimov/off-canvas/index.js